// extracted by mini-css-extract-plugin
export default {"baseListPage":"ListPage_baseListPage__LovQZ","actionBar":"ListPage_actionBar__zgkl+","title":"ListPage_title__fYTm9","searchForm":"ListPage_searchForm__c6rDW"};